import { validateAdminSignInInput } from "../../controllers/adminSignInController";

/**
 * react-hook-form resolver: same rules as {@link validateAdminSignInInput} (no network).
 * @type {import('react-hook-form').Resolver<{ email: string, password: string }>}
 */
export function adminSignInFormResolver(values) {
  const v = validateAdminSignInInput(values);
  if (v.ok) {
    return {
      values: { email: v.email, password: v.password },
      errors: {},
    };
  }
  /** @type {import('react-hook-form').FieldErrors<{ email: string, password: string }>} */
  const errors = {};
  if (v.fieldErrors.email) {
    errors.email = { type: "validation", message: v.fieldErrors.email };
  }
  if (v.fieldErrors.password) {
    errors.password = { type: "validation", message: v.fieldErrors.password };
  }
  return { values: {}, errors };
}
